import { createFileRoute, redirect } from "@tanstack/react-router";

// Adkiro advertises property only since 30 Sep 2026; old links land on the homepage.
export const Route = createFileRoute("/meta-ads-for-ecommerce")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
